const API_URL = process.env.REACT_APP_API_URL;

export const fetchLogsByStudentId = async (studentId, page = 1, limit = 50) => {
  try {
    const res = await fetch(
      `${API_URL}/api/logs/student/${studentId}?page=${page}&limit=${limit}`
    );
    if (!res.ok) throw new Error("Failed to fetch logs");
    return await res.json();
  } catch (error) {
    console.error("fetchLogsByStudentId error:", error);
    throw error;
  }
};

export const fetchLogsByBatchId = async (batchId, page = 1, limit = 100) => {
  try {
    const res = await fetch(
      `${API_URL}/api/logs/batch/${batchId}?page=${page}&limit=${limit}`
    );
    if (!res.ok) throw new Error("Failed to fetch batch logs");
    return await res.json();
  } catch (error) {
    console.error("fetchLogsByBatchId error:", error);
    throw error;
  }
};
